<span class="d-flex align-items-center position-relative w-100">
  <ng-content></ng-content>
  <i *ngIf="!isDirectLink && showLinkArrow" nz-icon nzType="right"></i>
  <i *ngIf="isDirectLink" nz-icon nzType="arrow-right"></i>
</span>
